/**
 * Clickable stat card component for dashboard statistics
 * Extends StatsCard with click functionality
 */

import { LucideIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export interface ClickableStatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  description?: string;
  onClick?: () => void;
  iconColor?: string;
  className?: string;
  testId?: string;
}

export function ClickableStatCard({
  title,
  value,
  icon: Icon,
  description,
  onClick,
  iconColor = "text-muted-foreground",
  className,
  testId,
}: ClickableStatCardProps) {
  return (
    <Card
      className={cn(
        "cursor-pointer hover-elevate active-elevate-2 transition-all",
        onClick && "cursor-pointer",
        className
      )}
      onClick={onClick}
      data-testid={testId || `stat-${title.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div>
            <div className="text-sm text-muted-foreground mb-1">{title}</div>
            <div className="text-3xl font-bold">{value}</div>
            {description && (
              <div className="text-xs text-muted-foreground mt-1">{description}</div>
            )}
          </div>
          <Icon className={cn("h-8 w-8 opacity-70", iconColor)} />
        </div>
      </CardContent>
    </Card>
  );
}

